import { AbstractControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

export function isControlHasError(control: AbstractControl | null, validationType: string): boolean {
  if (!control) {
    return false;
  }
  return control.hasError(validationType) && control.touched;
}

export function getEmailErrorMessage(
  control: AbstractControl | null,
  translate: TranslateService,
  options?: { fieldName?: string; isInvalidField?: boolean }
): string {
  if (!control) return '';
  if (isControlHasError(control, 'required')) {
    const name = options?.fieldName || translate.instant('AUTH.INPUT.EMAIL_ADDRESS');
    return translate.instant('AUTH.VALIDATION.REQUIRED', { name });
  }
  if (isControlHasError(control, 'email')) {
    if (options?.isInvalidField) {
      return translate.instant('AUTH.VALIDATION.INVALID_FIELD');
    }
    return translate.instant('AUTH.VALIDATION.INVALID_EMAIL');
  }
  if (isControlHasError(control, 'minlength')) {
    return translate.instant('AUTH.VALIDATION.MIN_LENGTH_FIELD') + ' 3';
  }
  if (isControlHasError(control, 'maxlength')) {
    return translate.instant('AUTH.VALIDATION.MAX_LENGTH_FIELD') + ' 320';
  }
  return '';
}

export function getPasswordErrorMessage(
  control: AbstractControl | null,
  translate: TranslateService,
  fieldName?: string
): string {
  if (!control) return '';
  if (isControlHasError(control, 'required')) {
    const name = fieldName || translate.instant('AUTH.INPUT.PASSWORD');
    return translate.instant('AUTH.VALIDATION.REQUIRED', { name });
  }
  if (isControlHasError(control, 'maxlength')) {
    return translate.instant('AUTH.VALIDATION.MAX_LENGTH_FIELD') + ' 100';
  }
  return '';
}

export function getConfirmPasswordErrorMessage(control: AbstractControl | null, translate: TranslateService): string {
  if (!control) return '';
  if (isControlHasError(control, 'required')) {
    return translate.instant('AUTH.VALIDATION.REQUIRED', { name: translate.instant('AUTH.RESET.REENTERNEWPASSWORD') });
  }
  if (isControlHasError(control, 'maxlength')) {
    return translate.instant('AUTH.VALIDATION.MAX_LENGTH_FIELD') + ' 100';
  }
  if (isControlHasError(control, 'ConfirmPassword')) {
    return "Password didn't match.";
  }
  return '';
}

export function getOrganizationErrorMessage(control: AbstractControl | null, translate: TranslateService): string {
  if (!control) return '';
  if (isControlHasError(control, 'required')) {
    return translate.instant('AUTH.VALIDATION.REQUIRED', { name: 'Organization Name' });
  }
  if (isControlHasError(control, 'minlength')) {
    return translate.instant('AUTH.VALIDATION.MIN_LENGTH_FIELD') + ' 3';
  }
  if (isControlHasError(control, 'maxlength')) {
    return translate.instant('AUTH.VALIDATION.MAX_LENGTH_FIELD') + ' 100';
  }
  return '';
}

export function getNameErrorMessage(control: AbstractControl | null, translate: TranslateService): string {
  if (!control) return '';
  if (isControlHasError(control, 'required')) {
    return translate.instant('AUTH.VALIDATION.REQUIRED', { name: 'Name' });
  }
  if (isControlHasError(control, 'minlength')) {
    return translate.instant('AUTH.VALIDATION.MIN_LENGTH_FIELD') + ' 3';
  }
  if (isControlHasError(control, 'maxlength')) {
    return translate.instant('AUTH.VALIDATION.MAX_LENGTH_FIELD') + ' 100';
  }
  return '';
}

export function getOtpErrorMessage(control: AbstractControl | null, translate: TranslateService): string {
  if (!control) return '';
  if (isControlHasError(control, 'required')) {
    return translate.instant('AUTH.VALIDATION.OTP_REQUIRED');
  }
  if (isControlHasError(control, 'minlength')) {
    return 'OTP length should be 6.';
  }
  if (isControlHasError(control, 'invalidReset')) {
    return translate.instant('AUTH.VALIDATION.INVALID_RESET');
  }
  return '';
}

